import { servicesApi } from '@/services/api/deprecated';

export const trackEvent = (eventName: string, properties: object, environmentId: number) => {
  if (environmentId == null) {
    return Promise.resolve();
  }
  return servicesApi.post<void>(`/environments/${environmentId}/track_event`, { properties, event: eventName });
};
